import store, { types } from '../store';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['auth']),
  },
  clearToken() {
    store.commit(types.SET_AUTH, {});
  },
  setStorageData(type, data) {
    if (data) {
      store.commit(type, data);
    } else {
      store.commit(type);
    }
  },
  loadAuthStorage() {
    store.dispatch(types.GET_USER);
  },
};



// WEBPACK FOOTER //
// ./src/services/helper.js